import React from 'react'
// Components
import ReactModal from 'react-modal'
import styles from './DiscountDetailModal.module.scss'

const DiscountDetailModal = ({ showModal, setShowModal, discount }) => {
  if (typeof window !== 'undefined') {
    ReactModal.setAppElement('body')
  }

  return (
    <ReactModal
      isOpen={showModal}
      overlayClassName={styles.modalOverlay}
      className={styles.modal}
      onRequestClose={() => setShowModal(false)}
    >
      <div className={styles.closeButton} onClick={() => setShowModal(false)}>
        <img src="/terrace-modal/close.svg" alt="close icon" />
      </div>
      {!!discount?.terms && (
        <div dangerouslySetInnerHTML={{ __html: discount?.terms }} />
      )}
    </ReactModal>
  )
}

export default DiscountDetailModal
